import { Env } from '../../env';
import { ApiClient } from '../../http/api_client';

export default class ReviewRepository {
  static feedback = (url: string, usefulness: boolean) => {
    return ApiClient.postWithStatusCode(Env.SETTING.userPublicApi.urlBase + url, { usefulness });
  };

  static deleteReview = (url: string) => {
    return ApiClient.deleteWithStatusCode(Env.SETTING.userPublicApi.urlBase + url);
  };
}
